// extracted by mini-css-extract-plugin
export default {"title":"delete_title__IXb7M","buttonPart":"delete_buttonPart__kImvE","buttonCancel":"delete_buttonCancel__bsCR8","buttonDelete":"delete_buttonDelete__VF1w-"};